<template>
    <div class="w-full space-y-3">
        <Head title="Reports"/>
        <div class="flex justify-between">
            <h1 class="mt-2 text-2xl font-bold leading-7 text-gray-900 sm:text-3xl">Invoice Status Report (Clients)</h1>
            <a :href="route('frontend.reports.invoice_status_report_clients_export', {
                _query: {
                    starts_at: form.starts_at,
                    ends_at: form.ends_at,
                    fixture_type: form.fixture_type,
                    user: form.user,
                    invoice_status: form.invoice_status,
                    trading_entity: form.trading_entity
                }})" class="py-3 px-3 border border-transparent shadow-sm text-sm leading-4 rounded-md text-white bg-pitch-purple focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-amaze-coral w-40 text-center">Download</a>
        </div>
    </div>
    <br />
    <div class="grid grid-cols-3 gap-2">
        <div class="" v-if="trading_details.length > 1">
            <label for="trading-entity" class="block text-sm font-medium text-gray-700">Trading Entity</label>
            <select id="trading-entity" v-model="form.trading_entity"
                class="mt-2 bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500">
                <option value="" v-html="'All'"></option>
                <option v-for="(trading_detail, index) in trading_details" :key="index" :value="trading_detail.id" :selected="form.trading_entity === trading_detail.id" v-html="trading_detail.trading_name"></option>
            </select>
        </div>
        <div class="">
            <label for="start-date" class="block text-sm font-medium text-gray-700">Start Date <span v-if="formattedStartDate">({{ formattedStartDate }})</span></label>
            <input v-model="form.starts_at" name="start-date" type="date" class="mt-2 bg-white border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 datepicker-input" placeholder="Select start date">
        </div>
        <div class="">
            <label for="end-date" class="block text-sm font-medium text-gray-700">End Date <span v-if="formattedEndDate">({{ formattedEndDate }})</span></label>
            <input v-model="form.ends_at" name="end-date" type="date" class="mt-2 bg-white border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 datepicker-input" placeholder="Select end date">
        </div>
    </div>
    <div class="flex gap-2 w-full items-center mt-2">
        <v-select class="mt-1 block w-full bg-white rounded-md shadow-sm focus:outline-none focus:ring-gray-900 focus:border-gray-900 sm:text-sm" :options="fixture_types" label="name" :reduce="fixture_types => fixture_types.id" v-model="form.fixture_type" placeholder="Fixture Type" />

        <v-select class="mt-1 block w-full bg-white rounded-md shadow-sm focus:outline-none focus:ring-gray-900 focus:border-gray-900 sm:text-sm" :options="users" label="name" :reduce="users => users.id" v-model="form.user" placeholder="User" />

        <v-select class="mt-1 block w-full bg-white rounded-md shadow-sm focus:outline-none focus:ring-gray-900 focus:border-gray-900 sm:text-sm" :options="statuses" label="status" :reduce="statuses => statuses.status" v-model="form.invoice_status" placeholder="Status" />
    </div>
    <br />
    <div class="bg-white py-6 px-4 sm:p-6 shadow mb-6">
        <div class="flex flex-col mt-3 space-y-3">
            <div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                <div class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
                    <div class="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
                        <table class="min-w-full divide-y divide-gray-200">
                            <thead class="bg-gray-50">
                                <tr>
                                    <th scope="col"
                                        class="px-6 py-3 text-left text-xs text-gray-500 uppercase tracking-wider">
                                        Fixture
                                    </th>
                                    <th scope="col"
                                        class="px-6 py-3 text-left text-xs text-gray-500 uppercase tracking-wider">
                                        Fixture Date
                                    </th>
                                    <th scope="col"
                                        class="px-6 py-3 text-left text-xs text-gray-500 uppercase tracking-wider">
                                        Fixture Code
                                    </th>
                                    <th scope="col"
                                        class="px-6 py-3 text-left text-xs text-gray-500 uppercase tracking-wider">
                                        Trading Entiy
                                    </th>
                                    <th scope="col"
                                        class="px-6 py-3 text-left text-xs text-gray-500 uppercase tracking-wider">
                                        Team Manager
                                    </th>
                                    <th scope="col"
                                        class="px-6 py-3 text-left text-xs text-gray-500 uppercase tracking-wider">
                                        Invoice Amount
                                    </th>
                                    <th scope="col"
                                        class="px-6 py-3 text-left text-xs text-gray-500 uppercase tracking-wider">
                                        Total Outstanding
                                    </th>
                                    <th scope="col"
                                        class="px-6 py-3 text-left text-xs text-gray-500 uppercase tracking-wider">
                                        Invoice Status
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-if="Object.values(invoices).length > 0" v-for="(invoice, index) in invoices.data" :key="index">
                                    <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                        <a :href="route('frontend.fixture.show' , invoice.quote.fixture.id)">
                                            {{ invoice.quote.fixture.title }}
                                        </a>
                                    </td>
                                    <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                        <a :href="route('frontend.fixture.show' , invoice.quote.fixture.id)">
                                            {{ moment(invoice.quote.fixture.starts_at, 'YYYY-MM-DD').format('DD MMM YYYY') }}
                                        </a>
                                    </td>
                                    <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                        <a :href="route('frontend.fixture.show' , invoice.quote.fixture.id)">
                                            {{ invoice.quote.fixture.reference }}
                                        </a>
                                    </td>
                                    <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                        {{ invoice.quote.client.trading_details ? invoice.quote.client.trading_details.trading_name : '' }}
                                    </td>
                                    <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                        {{ invoice.quote.fixture.travel_manager ? invoice.quote.fixture.travel_manager.name : '' }}
                                    </td>
                                    <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                        £{{ invoice.amount.toFixed(2) }}
                                    </td>
                                    <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                        £{{ (invoice.amount - invoice.amount_paid).toFixed(2) }}
                                    </td>
                                    <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                        {{ invoice.status }}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <Pagination :links="invoices.links"/>
        </div>
    </div>
</template>

<script>
    import Authenticated from "@/Layouts/Authenticated";
    import {Link, Head, useForm} from "@inertiajs/vue3";
    import Pagination from "@/Components/Pagination";
    import mapValues from "lodash/mapValues";
    import debounce from "lodash/debounce";
    import pickBy from "lodash/pickBy";
    import moment from "moment/moment";

    export default {
        layout: Authenticated,
        components: {
            Head,
            Link,
            Pagination
        },
        props: ['fixture_types', 'users', 'starts_at', 'ends_at', 'fixture_type_id', 'user_id', 'invoice_status', 'invoices', 'invoice_statuses', 'trading_details'],
        data(props) {
            return {
                form: {
                    starts_at: props.starts_at,
                    ends_at: props.ends_at,
                    fixture_type: props.fixture_type_id,
                    user: props.user_id,
                    invoice_status: props.invoice_status,
                    trading_entity: null
                }
            }
        },
        computed: {
            statuses() {
            const formattedStatuses = [];

            // Iterate over the keys and values of the statuses object
            for (const key in this.invoice_statuses) {
                if (Object.hasOwnProperty.call(this.invoice_statuses, key)) {
                    const id = key;
                    const status = this.invoice_statuses[key];

                    formattedStatuses.push({ id, status });
                }
            }

            return formattedStatuses;
        },
            formattedStartDate() {
                if (this.form.starts_at) {
                    return moment(this.form.starts_at).format('DD MMM YYYY');
                }
                return '';
            },
            formattedEndDate() {
                if (this.form.ends_at) {
                    return moment(this.form.ends_at).format('DD MMM YYYY');
                }
                return '';
            }
        },
        methods: {
            reset() {
                this.form = mapValues(this.form, () => null)
            },
        },
        created() {
            this.moment = moment
        },
        watch: {
            form: {
                deep: true,
                handler: debounce(function () {
                    this.$inertia.get(route('frontend.reports.invoice_status_report_clients'), pickBy(this.form), {preserveState: true, preserveScroll: true})
                }, 500),
            },
        }
    }
</script>
